import React, { useEffect, useState } from "react";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import { useNavigate } from "react-router-dom";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { toast } from "react-hot-toast";
import { getVendorName } from "../../../utils/getVendorName";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import { downloadSampleCSV } from "../../../utils/downloadSampleCsv";
import { CircleLoaderComponent } from "../../../components/Loader/CircleLoaderComponent";
import CustomExport from "../../../components/CustomExport/CustomExport";
import { useFetchOrdersByIdMutation, useFetchOrdersByTypeMutation, useInsertOrdersMutation, useOrderErrorLogsMutation } from "../../../features/tenant/Orders/ordersApi"; import { hasPermission } from "../../../utils/hasPermission";
import dayjs from "dayjs";

const OrderErrorLogs = () => {
  const navigate = useNavigate();
  const [myList, setMyList] = useState([])
  const [errorRows, setErrorRows] = useState([])
  const [errorUploadModal, setErrorUploadModal] = useState(false)
  const [successRows, setSuccessRows] = useState([])
  const [successUploadModal, setSuccessUploadModal] = useState(false)

  const [
    fetchOrderErrorLogs,
    {
      data: ordersErrorData,
      isLoading: ordersErrorIsLoading,
      isError: ordersErrorIsError,
      error: ordersError,
    },
  ] = useOrderErrorLogsMutation();

  const fetchOrderError = () => {
    fetchOrderErrorLogs({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
    });
  }

  useEffect(() => {
    fetchOrderError()
  }, [])
  useEffect(() => {
    if (ordersError) {
      toast.error(ordersError?.data?.message)
    }
    if (ordersErrorData?.body?.errorRows.length > 0) {
      setMyList(ordersErrorData?.body?.errorRows)
    }
  }, [ordersError, ordersErrorData])


  if (ordersErrorIsLoading) {
    toast.dismiss();
  }

  const columns = [
    {
      name: "SNo",
      cell: (row, idx) => Number(idx + 1),
      sortable: true,
      width:"150px"
    },
    {
      name: "Success Count",
      cell: (row) => row?.success_logs?.length ?? 0,
      width:"150px"
    },
    {
      name: "Failure Count",
      cell: (row) => row?.error_logs?.length ?? 0,
      width:"150px"
    },
    {
      name: "Upload Date",
      cell: (row) => dayjs(row?.created_at).format("YYYY-MM-DD HH:mm:ss"),
      sortable: true,
      width:"150px"
    },
    {
      name: "",
      cell: (row) => (
        <>
          <button
            className="flex justify-center items-center rounded bg-primary px-3 pb-1.5 break-normal pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] mx-3"
            onClick={() => {
              setSuccessUploadModal(true)
              setSuccessRows(row.success_logs)
            }}
          >
            View Success Logs
          </button>
          <button
            className="flex justify-center items-center rounded bg-primary px-3 pb-1.5 break-normal pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] mx-3"
            onClick={() => {
              setErrorUploadModal(true)
              setErrorRows(row.error_logs)
            }}
          >
            View Failure Logs
          </button>
        </>
      ),
      sortable: true,
      minWidth: "100px",
    }
  ];

  const generateErrorColumn = (type) => {
    return ([
      {
        name: "Customer Code",
        cell: (row) => row.customerCode,
        sortable: true,
        width: "100px",
      },
      {
        name: "Customer Name",
        cell: (row) => row?.customerName,
        sortable: true,
        width: "100px",
      },
      {
        name: "Bill Type",
        cell: (row) => row.billType,
        sortable: true,
        width: "100px",

      },
      {
        name: "Invoice Number",
        cell: (row) => row.invoiceNumber,
        sortable: true,
        width: "100px",

      },
      {
        name: "Invoice Date",
        cell: (row) => row.invoiceDate,
        sortable: true,
        width: "100px",
      },
      {
        name: "SKU Code",
        cell: (row) => row.skuCode,
        sortable: true,
        width: "100px",
      },
      {
        name: "Quantity",
        cell: (row) => row.quantity,
        sortable: true,
        width: "100px",
      },
      ...type==='error' ? 
      [{
        name: "Reason",
        cell: (row) => row.reason,
        sortable: false,
        width: "100px",
      }] : []
    ])
  }

  function downloadCSVFromJSON(row, fileName) {
    if (!row || row.length === 0) {
      console.error("downloadCSVFromJSON: Empty JSON");
      return;
    }

    // Extract headers
    const headers = Object.keys(row[0]);

    // Convert JSON to CSV format
    const escapeCSV = (value) => {
      if (value === null || value === undefined) return "";
      const str = String(value);
      // Escape quotes and wrap fields with commas
      if (str.includes(",") || str.includes('"') || str.includes("\n")) {
        return `"${str.replace(/"/g, '""')}"`;
      }
      return str;
    };

    const csvRows = [
      headers.join(","), // header row
      ...row.map((row) =>
        headers.map((field) => escapeCSV(row[field])).join(",")
      )
    ];

    const csvString = csvRows.join("\n");

    // Create a Blob
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    // Create hidden download link
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName.endsWith(".csv") ? fileName : fileName + ".csv");
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }


  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center ">
        <div className="w-full">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            Order Rows
            <LinksComponent />
          </div>

          <div className="p-3">
            <div className="flex gap-2">
              <div className="w-full bg-white shadow rounded-lg">


                <DataTableComponent
                  columns={columns}
                  data={myList}
                  pagination={false}
                ></DataTableComponent>

              </div>

            </div>
          </div>

        </div>


        {errorUploadModal && (
          <ModalComponent show={errorUploadModal} setShow={(action) => {
            if (!action) {
              setErrorRows([])
              setErrorUploadModal(false)
            }
          }} size="4xl">
            <div className="w-full p-4">
              <div className="flex justify-between">
              <div className="text-xl font-bold">
                Failure Rows
              </div>
               <button
            onClick={() => downloadCSVFromJSON(errorRows, `order_error_rows_${dayjs().format("YYYYMMDD_HHmmss")}.csv`)}
            className="btn btn-primary"
          >
            Download CSV
          </button>
          </div>
              <DataTableComponent
                columns={generateErrorColumn("error")}
                data={errorRows}
                pagination={false}
              ></DataTableComponent>
            </div>
          </ModalComponent>
        )}

        {successUploadModal && (
          <ModalComponent show={successUploadModal} setShow={(action) => {
            if (!action) {
              setSuccessRows([])
              setSuccessUploadModal(false)
            }
          }} size="3xl">
            <div className="w-full p-4">
              <div className="flex justify-between">
              <div className="text-xl font-bold">
                Success Rows
              </div>
               <button
            onClick={() => downloadCSVFromJSON(successRows, `order_success_rows_${dayjs().format("YYYYMMDD_HHmmss")}.csv`)}
            className="btn btn-primary"
          >
            Download CSV
          </button>
          </div>
              <DataTableComponent
                columns={generateErrorColumn("success")}
                data={successRows}
                pagination={false}
              ></DataTableComponent>
            </div>
          </ModalComponent>
        )}

        {/*
        {orderLinesModal && (
          <ModalComponent show={orderLinesModal} setShow={(action) => {
            console.log("mMO", action)
            if (!action) {
              setOrderLines([])
              setOrderLinesModal(false)
            }
          }} size="3xl">
            <div className="w-full p-4">
              <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                Order Details
              </div>
              <DataTableComponent
                columns={orderDetailColumn}
                data={orderLines}
                pagination={false}
              ></DataTableComponent>
            </div>
          </ModalComponent>
        )}

        {showModal2 && (
          <ModalComponent show={showModal2} setShow={setShowModal2} size="md">
            <div className="w-full p-4">
              {
                <div className="flex justify-center mt-3 mb-3">
                  <button
                    type="submit"
                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                    onClick={() =>
                      downloadSampleCSV([
                        {
                          name: "customerCode",
                        },
                        {
                          name: "customerName",
                        },
                        {
                          name: "billType"
                        },
                        {
                          name: "invoiceNumber",
                        },
                        {
                          name: "invoiceDate",
                        },
                        {
                          name: "skuCode",
                        },
                        {
                          name: "quantity",
                        }
                      ])
                    }
                  >
                    Sample Csv Download
                  </button>
                </div>
              }
              <div className="w-full m-auto  justify-center ">
                <div className="flex items-center justify-center w-full">
                  <label
                    for="dropzone-file"
                    className="flex flex-col items-center justify-center w-full h-20 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50   hover:bg-gray-100  "
                  >
                    <div className="flex flex-col items-center justify-center ">
                      <svg
                        aria-hidden="true"
                        className="w-20 h-20 mb-3 text-gray-400 mt-2"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          strokeLinejoin="round"
                          stroke-width="2"
                          d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                        ></path>
                      </svg>
                      <p className="mb-2 text-sm text-gray-500 text-center">
                        <span className="font-semibold">Choose CSV file</span>
                        <div>Click to upload or drag and drop</div>
                      </p>
                    </div>
                    <input
                      id="dropzone-file"
                      type="file"
                      className="hidden"
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      onChange={handleOnChange}
                    />
                  </label>
                </div>
              </div>
              <div className="flex justify-center mt-3">
                <button
                  type="submit"
                  className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                  onClick={(e) => handleOnSubmit()}
                >
                  Add
                </button>
              </div>
            </div>
          </ModalComponent>
        )} */}
      </div>

    </>
  );
};

export default OrderErrorLogs;
